<template>
  <div class="partner-base">

    <img :src="'http://'+UrlList" v-if="UrlList">
    <div class="partner-content">
      <image-show :image-list="result"></image-show>
    </div>

  </div>
</template>

<script>
import ImageShow from "../../components/ImageX/ImageShow";
export default {
  name: "Partner",
  components: {ImageShow},
  data(){
    return{
      data:{
        'pageNumber':0,
        'pageSize':16,
      },
      result:{},
      UrlList:{}
    }
  },
  created() {
    this.GetData(this.data)
    this.GetUrlData()
  },
  methods:{
    GetData(data){
        this.$axios.post('/api/supplier/getList',data).then(res=>{
          this.result=res.data.data.records
        })
    },
    GetUrlData(){
      this.$axios.get('/api/photo/getBuildBanana',{params:{
        id:29
        }}).then(res=>{
        this.UrlList=res.data.data[0].photoList[0].address;

      })
    }
  }
}
</script>

<style lang="less" scoped>
img{
  width: 100%;
  height: 250px;
  object-fit: cover;
}
.partner-base{
  .partner-content{
    min-height: 60vh;

  }
}

</style>